import {Link} from 'react-router-dom';
import premierimg from '../assets/premierleague.png';
import '../css/Teams.css';

const Teams = () => {
    return (
        <main id="teams-content">
            <h2 id="quest">What League Teams Would You Like To See?</h2>
            <Link to="/teams/premier-league">
                <section id="teams-section">
                    <div id="teams-container">
                        <img id="teams-img" src={premierimg} alt="Premier League logo"/>
                    </div>
                </section>
            </Link>
        </main>
    );
};

export default Teams;